var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_76_868",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "current"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_76_868)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.69999 17.2998C8.51665 17.1165 8.42499 16.8831 8.42499 16.5998C8.42499 16.3165 8.51665 16.0831 8.69999 15.8998L12.6 11.9998L8.69999 8.0998C8.51665 7.91647 8.42499 7.68314 8.42499 7.3998C8.42499 7.11647 8.51665 6.88314 8.69999 6.6998C8.88332 6.51647 9.11665 6.4248 9.39999 6.4248C9.68332 6.4248 9.91665 6.51647 10.1 6.6998L14.7 11.2998C14.8 11.3998 14.871 11.5081 14.913 11.6248C14.9543 11.7415 14.975 11.8665 14.975 11.9998C14.975 12.1331 14.9543 12.2581 14.913 12.3748C14.871 12.4915 14.8 12.5998 14.7 12.6998L10.1 17.2998C9.91665 17.4831 9.68332 17.5748 9.39999 17.5748C9.11665 17.5748 8.88332 17.4831 8.69999 17.2998Z",
    fill: "current"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow_right.decedd404eee2e521972d30cfa2ae110.svg";
export { ForwardRef as ReactComponent };